import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MAP_IMAGE from "../../../../assets/images/maps.png";
import { tourItineraryDownload } from "../../packageDetailSlice";
import { useLocation, useParams } from "react-router-dom";
import { getSessionId, setSessionId } from "../../../../common/helpers";
import { API_APP_TEST_PORTAL_URL } from "../../../../app/config";
import { axiosApiInstance } from "../../../../app/axios";
import { ErrorToast } from "../../../../components/common/Toast";

const Itinerary = () => {
  const TourDetails = useSelector((state) => state.packageDetail.TourDetails);
  const location = useLocation();
  const { TourURL } = useParams();
  const tourData = location.state?.tourData;

  const [itineraryLoading, setItineraryLoading] = useState(false);

  const handleDownloadItinerary = async () => {
    const sessionId = getSessionId();
    const payload = {
      TourID: tourData?.ID,
      RateType: tourData?.Ratetype,
      NoOfNights: tourData?.NoOfNights?.toString(),
      RoomTypeID: tourData?.RoomTypeID,
      TourURL: TourURL,
      SessionID: sessionId,
      CustomerID: "0",
    };

    try {
      setItineraryLoading(true);
      const response = await axiosApiInstance.post(
        `${API_APP_TEST_PORTAL_URL}/Tour/TourItineraryDownload`,
        payload
      );
      const ItineraryUrl = response.data?.Data[0]?.PdfPath;
      if (ItineraryUrl) {
        window.open(ItineraryUrl, "_blank");
      } else {
        ErrorToast("No Itinerary Found!");
      }
      setItineraryLoading(false);
    } catch (error) {
      setItineraryLoading(false);
      ErrorToast(error?.message || "Something went Wrong!");
      console.log("error: " + error?.message);
    }
  };

  return (
    <div
      className="tab-pane fade show active"
      id="Itinerary"
      role="tabpanel"
      aria-labelledby="Itinerary-tab"
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 10,
        }}
      >
        <h6 style={{ alignSelf: "center", marginBottom: 0 }}>ITINERARY</h6>
        <button
          disabled={itineraryLoading}
          onClick={handleDownloadItinerary}
          className="btn btn-fill"
        >
          Download
        </button>
      </div>
      <div className="accordion" id="accordionExample">
        {TourDetails?.touritinerary?.map((itinerary, index) => (
          <div className="accordion-item" key={itinerary?.ItineraryDay}>
            <h2
              className="accordion-header"
              id={"heading" + itinerary?.ItineraryDay}
            >
              <button
                className={`accordion-button ${index === 0 ? "" : "collapsed"}`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={"#collapse" + itinerary?.ItineraryDay}
                aria-expanded={index === 0 ? "true" : "false"}
                aria-controls={"collapse" + itinerary?.ItineraryDay}
              >
                <div className="days-left">
                  <span>
                    <strong>Day {itinerary?.ItineraryDay}</strong>
                  </span>
                </div>
                <h6>
                  <img src={MAP_IMAGE} />
                  {itinerary?.ItineraryTitle}
                </h6>
              </button>
            </h2>
            <div
              id={"collapse" + itinerary?.ItineraryDay}
              className={`accordion-collapse collapse ${
                index === 0 ? "show" : ""
              }`}
              aria-labelledby={"heading" + itinerary?.ItineraryDay}
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <div
                  dangerouslySetInnerHTML={{
                    __html: itinerary?.ItineraryDescription || "",
                  }}
                ></div>
                <div className="stay-tb">
                  <ul>
                    {itinerary?.tourfcs?.map((fcs) => (
                      <li>
                        <img src={fcs?.Image} /> {fcs?.Name}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Itinerary;
